import { Component, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { OrderDataModel } from 'src/app/models/preliminaries/order-data.model';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { OrderService } from 'src/app/services/preliminaries/order.service';

@Component({
  selector: 'app-order-data',
  templateUrl: './order-data.component.html',
  styleUrls: ['./order-data.component.scss'],
  standalone: false
})
export class OrderDataComponent implements OnInit {

  private readonly config = inject(DynamicDialogConfig);
  private readonly dateConverterService = inject(DateConverterService);
  private readonly orderService = inject(OrderService);
  private readonly ref = inject(DynamicDialogRef, { optional: true });

  dateOrder: Date | null = null;
  loading: boolean = false;
  observations: { label: string, value: string | null }[] = [];
  orderData: OrderDataModel = new OrderDataModel();
  orderId: number = 0;
  subscription: Subscription;

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.subscription = input$?.subscribe((inputs: any) => {
      this.orderId = inputs.orderId;
    });
    this.loading = true;
    await this.getOrderDataById();
    this.loading = false;
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  close() {
    this.ref?.close();
  }

  async getOrderDataById() {
    try {
      this.orderData = await firstValueFrom(this.orderService.getOrderDataById(this.orderId));
      this.dateOrder = this.dateConverterService.convertUtcToLocalDate(this.orderData.dateOrder);
      this.observations = [
        { label: 'Observación Técnica', value: this.orderData.observation },
        { label: 'Observación Comercial', value: this.orderData.observationCommercial },
        { label: 'Observación Remisión', value: this.orderData.observationRemission }
      ];
    } catch (error) {
      console.error('Error al buscar los datos del pedido.', error);
    }
  }
}
